import { Link, useNavigate } from 'react-router-dom';
import { useHomeContent } from '../lib/content';
import { PAYMENTS_ENABLED } from '../lib/features';
import { TariffsSection } from '../components/home/TariffsSection';

export function TariffsPage() {
  const { data } = useHomeContent();
  const tariffs = data?.tariffs ?? [];
  const navigate = useNavigate();

  return (
    <div className="pb-10">
      <section className="px-4 pb-2 pt-6 md:px-8 md:pt-10 xl:px-20">
        <div className="mx-auto max-w-[1280px]">
          <Link to="/" className="text-[14px] font-semibold text-accent">
            ← На главную
          </Link>
          <h1 className="mt-4 text-[38px] font-semibold leading-[1.08] tracking-[-0.02em] text-ink md:text-[56px]">
            Тарифы
          </h1>
          <p className="mt-3 max-w-2xl text-[16px] leading-6 text-muted md:text-[18px]">
            {PAYMENTS_ENABLED
              ? 'Выберите формат под свою ситуацию. Оплата один раз, без скрытых списаний.'
              : 'Выберите формат под свою ситуацию — стоимость и детали обсудим в чате.'}
          </p>
          <div className="mt-5 flex flex-wrap gap-3 text-[13px] text-muted">
            {PAYMENTS_ENABLED ? (
              <>
                <span className="rounded-lg bg-white/80 px-3 py-1.5">Оплата картой или СБП</span>
                <span className="rounded-lg bg-white/80 px-3 py-1.5">Возврат по заявке</span>
              </>
            ) : (
              <span className="rounded-lg bg-white/80 px-3 py-1.5">
                Подберём формат и ответим на вопросы в чате
              </span>
            )}
            <span className="rounded-lg bg-white/80 px-3 py-1.5">Юристы на связи 9:00–21:00</span>
          </div>
        </div>
      </section>

      <TariffsSection
        tariffs={tariffs}
        showHeader={false}
        onSelect={(tariff) =>
          navigate(PAYMENTS_ENABLED ? `/checkout?plan=${encodeURIComponent(tariff.key)}` : '/chat')
        }
      />

      <section className="px-4 md:px-8 xl:px-20">
        <div className="mx-auto max-w-[1280px] rounded-3xl border border-line bg-white/85 p-6 md:p-8">
          <h2 className="text-[22px] font-semibold text-ink">Чем отличаются тарифы</h2>
          <div className="mt-4 grid gap-3 md:grid-cols-3">
            {[
              ['Разбор', 'Один вопрос и развёрнутый ответ юриста в течение рабочего дня.'],
              ['Неделя', 'Можно уточнять и дополнять вопрос, юрист ведёт обращение до ответа.'],
              ['Ведение дела', 'Документы, черновик жалобы, сроки и сопровождение до результата.'],
            ].map(([title, text]) => (
              <div key={title} className="rounded-2xl bg-soft px-4 py-4">
                <div className="text-[15px] font-semibold text-ink">{title}</div>
                <div className="mt-1 text-[13px] leading-5 text-muted">{text}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
